module.exports = __webpack_public_path__ + "static/img/progress.4980bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/baggage/progress.png
// module id = dZc3
// module chunks = 0